import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { memo, useMemo } from "react";
import { VideoTimecodeFrames } from "~/components/AssetModal/Visualizer/VideoVisualizer/VideoVisualizerInner/components/VideoTimecodeFrames";
import { formatTimecodeValue, getTimecode } from "~/utils/VideoUtils";
export const VideoTimecode = /*#__PURE__*/ memo((param)=>{
    let { currentTime, frameCount, totalTime } = param;
    const { hours, minutes, seconds, frames } = useMemo(()=>{
        return getTimecode({
            currentTime,
            frameCount,
            totalTime
        });
    }, [
        currentTime,
        frameCount,
        totalTime
    ]);
    return /*#__PURE__*/ _jsxs("div", {
        className: "text-14 text-grey-11",
        "data-testid": "VIDEO_TIMECODE",
        style: {
            fontFeatureSettings: "'tnum' on"
        },
        children: [
            /*#__PURE__*/ _jsx("span", {
                children: formatTimecodeValue(hours)
            }),
            /*#__PURE__*/ _jsx("span", {
                children: ":"
            }),
            /*#__PURE__*/ _jsx("span", {
                children: formatTimecodeValue(minutes)
            }),
            /*#__PURE__*/ _jsx("span", {
                children: ":"
            }),
            /*#__PURE__*/ _jsx("span", {
                children: formatTimecodeValue(seconds)
            }),
            !!frames && !!frameCount && /*#__PURE__*/ _jsxs(_Fragment, {
                children: [
                    /*#__PURE__*/ _jsx("span", {
                        children: ":"
                    }),
                    /*#__PURE__*/ _jsx(VideoTimecodeFrames, {
                        frames: frames,
                        frameCount: frameCount
                    })
                ]
            })
        ]
    });
});
VideoTimecode.displayName = "VideoTimecode";
